import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    TextInput, Button, FormGroup, ComposedModal, ModalHeader, ModalBody, ModalFooter, Toggle
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { FindGHRSEmployer } from '../common/FindGHRSEmployer'
import { entitiesLabels } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { ComboBox } from '../../helpers/ComboBox'; //RITM1405215

export class TeamMemberModal extends Component {
    incidentTeamMemberModel = (props) => {

        if (props.isEditModal) {
            return { ...props.editModel };
        }

        return {
            id: null, //guid
            idIncident: null,//guid
            isTeamLeader: null, //RITM1405215
            idEmployer: null,  //guid 
            name: null,
            surname:null ,
            email:null,
            ghrS_ID: null,
            employer: {
                id: null, //guid
                 name: '',
                 ghrS_ID: '',
                 surname: '',
                 email: '',
            },
            role: null, //RITM1405215
            subjectDisciplineCompetence: '', //RITM1405215
            
        }
    }

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator({autoForceUpdate: this, locale: 'en'});
        this.handleChangeCombo = this.handleChangeCombo.bind(this); //RITM1405215
        this.state = {
            model: {
                ...this.incidentTeamMemberModel(props),
                  },
            mode: props.mode || 0,
            appRole: [ //RITM1405215
                { id: 'Team Leader', text: 'Team Leader' },
                { id: 'Team Member', text: 'Team Member' },
                { id: 'Sponsor', text: 'Sponsor' },
            ],
        };
    }
    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state);
        statusCopy[objName][inputName] = inputValue;

        this.setState(statusCopy);
    }
    handleChangeModel = (el) => {
        let inputName = el.target.name;
        let inputValue = el.target.value;
        let objName = el.target.alt;
        this.updateState(inputName, inputValue, objName);
    }

    handleChangeMode = (m) => {
        this.setState({ mode: m })
    }

    setEmployer = (employer) => {
        
        if (employer && employer.id) {
            let statusCopy = Object.assign({}, this.state.model);
            statusCopy.idEmployer = employer.id;
            statusCopy.employer = employer;

            this.setState({ model: statusCopy, mode: 2 ,setEmployer: 1 });
        }
    }

    save = () => {
        if(this.state.model.idEmployer != null){
            //RITM1405215
            if (this.validator.allValid()) {
                this.props.save(this.state.model);
            }else {
                this.validator.showMessages();
                showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.TEAMMEMBER + " required fields are missing  ");
                    this.forceUpdate();
                 }
            //End
        }
        else{
        if (this.validator.allValid()) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(re.test(String(this.state.model.email).toLowerCase())){
                this.props.save(this.state.model);
                showNotification.success(`${entitiesLabels.SUCCESS}`,"Team Member created successfully");
                }else{
                showNotification.warning(`${entitiesLabels.WARNING}`,
                `${entitiesLabels.TEAMMEMBER} error email. `
                );
            } 
        }else {
            this.validator.showMessages();
            showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.TEAMMEMBER + " required fields are missing  ");
                this.forceUpdate();
             }
        }
    }

    //RITM1405215
    handleChangeCombo = (inputName, selectedItem, objName) => {
        const inputValue = selectedItem ? selectedItem.id || selectedItem : null;
    
        const statusCopy = { ...this.state[objName] };
        statusCopy[inputName] = inputValue;
        this.setState({ [objName]: statusCopy });
      };
    //End

    render() {
        
        this.validator.purgeFields();
        const validations = {
            name: this.validator.message('name', this.state.model.idEmployer == null ? this.state.model.name : true , 'required'), //RITM1405215
            surname: this.validator.message('surname', this.state.model.idEmployer == null ? this.state.model.surname : true, 'required'), //RITM1405215
            email: this.validator.message('email', this.state.model.idEmployer == null ? this.state.model.email : 'xxx@yyy.com' , 'required|email'), //RITM1405215
            role: this.validator.message('role', this.state.model.idEmployer != null ? this.state.model.role : true, 'required'), //RITM1405215
            
        }
        const modalHeader = {
            title: (this.props.isEditModal ? 'Edit ' : 'Add new '),
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false)
        };
        const { title, isOpenModal } = this.props;


        //RITM1405215
        const selectedItemCombo = {
            role: (this.state.appRole || []).find(
                (el) => el.id == this.state.model.role
              ),
        }
        //End

        return (
            this.state.mode == 1 ?
                <FindGHRSEmployer isOpenModal={isOpenModal} onCancel={()=>this.props.toggleModal(false)} onOk={this.setEmployer} />
                :
                <ComposedModal
                    className="light-modal"
                    open={isOpenModal}
                    danger="false"
                    onClose={() => { return false; }}
                >
                    <ModalHeader className="margin-modal" {...modalHeader} ><p>{title || ''}</p></ModalHeader>
                    <ModalBody className="margin-modal">
                        {
                             this.state.mode == 0 ?
                             <div className="bx--row two-button-center modal--elemnts-buttons" >
                                 <Button kind="primary" className="bx--col-md-6" onClick={() => this.handleChangeMode(1)}>GHRS research</Button>
                                 <Button kind='primary' className="bx--col-md-6" onClick={() => this.handleChangeMode(2)}>Manual input</Button>
                             </div>
                             :
                            <div className="bx--grid--full-width">
                                <div className="bx--row">
                                    {/* RITM1405215 */}
                                    {this.state.model.idEmployer != null ?
                                        <FormGroup legendText="Role*" className="bx--col-md-4 bx--col-lg-6">
                                            <ComboBox
                                                id="role"
                                                placeholder="Select"
                                                name="role"
                                                alt="model"
                                                onChange={this.handleChangeCombo}
                                                itemToString={item => (item ? item.text : '')}
                                                initialSelectedItem={selectedItemCombo.role}
                                                items={this.state.appRole}                                                                                                                 
                                                invalid={validations.role != null}
                                            />
                                        {validations.role}
                                        </FormGroup>:"" }
                                    {/* End */}
                                    <FormGroup legendText="Name*" className="bx--col-md-4 bx--col-lg-6">
                                        <TextInput
                                            id="name"
                                            name="name"
                                            alt="model"
                                            placeholder="Input Name"
                                            value={this.state.model.name != null?  this.state.model.name : this.state.model.employer ? this.state.model.employer.name : ''}
                                             type="text"
                                            hideLabel={true}
                                            labelText=""
                                            disabled={this.state.model.idEmployer != null}
                                            onChange={this.handleChangeModel}
                                            invalid={validations.name != null}
                                            />
                                    {validations.name}
                                    </FormGroup>
                                    <FormGroup legendText="Surname*" className="bx--col-md-4 bx--col-lg-6">
                                        <TextInput
                                            id="txt-surname"
                                            name="surname"
                                            alt="model"
                                            placeholder="Input Surname"
                                            value={  this.state.model.surname ?   this.state.model.surname: this.state.model.employer ? this.state.model.employer.surname :'' }
                                            type="text"
                                            hideLabel={true}
                                            labelText=""
                                            disabled={this.state.model.idEmployer != null}
                                            onChange={this.handleChangeModel}
                                            invalid={validations.surname != null}
                                            />
                                    {validations.surname}
                                    </FormGroup>
                                    <FormGroup legendText="Badge Number" className="bx--col-md-4 bx--col-lg-6">
                                        <TextInput
                                            id="txt-badgeNumber"
                                            name="ghrS_ID"
                                            alt="model"
                                            placeholder=""
                                            value={this.state.model.ghrS_ID ?   this.state.model.ghrS_ID: this.state.model.employer ? this.state.model.employer.ghrS_ID : '' }
                                            type="text"
                                            hideLabel={true}
                                            labelText=""
                                            disabled={this.state.model.idEmployer != null}
                                            onChange={this.handleChangeModel}
                                        />
                                    </FormGroup>
                                    <FormGroup legendText="Email* (Personal Email Addresses are not allowed)" className="bx--col-md-4 bx--col-lg-6">
                                        <TextInput
                                            id="txt-email"
                                            name="email"
                                            alt="model"
                                            placeholder="Input Email"
                                            value={this.state.model.email ?   this.state.model.email :  this.state.model.employer ? this.state.model.employer.email : ''  }
                                            type="text"
                                            hideLabel={true}
                                            labelText=""
                                            disabled={this.state.model.idEmployer != null}
                                            onChange={this.handleChangeModel}
                                            invalid={validations.email != null}
                                            title="&#9888; Do Not use Personal Accounts"
                                            />
                                    {validations.email}
                                    </FormGroup>
                                    {/* RITM1405215 */}
                                    <FormGroup legendText="Subject/Discipline of competence" className="bx--col-md-4 bx--col-lg-6">
                                        <TextInput
                                            id="txt-subjectDisciplineCompetence"
                                            name="subjectDisciplineCompetence"
                                            alt="model"
                                            placeholder="Input Subject/Discipline of competence"
                                            value={this.state.model.subjectDisciplineCompetence || ''}
                                            type="text"
                                            hideLabel={true}
                                            labelText=""
                                            onChange={this.handleChangeModel}
                                            />
                                    </FormGroup>
                                    {/* End */}

                                </div>
                            </div>
                        }
                    </ModalBody>
                    <ModalFooter >
                        <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>Cancel</Button>
                        <Button kind='primary' onClick={() => this.save()}>Save</Button>
                    </ModalFooter>
                </ComposedModal>
        );
    }
}

TeamMemberModal.propTypes = {
    save: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    isEditModal: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    mode: PropTypes.number,
    title: PropTypes.string,
};